module.exports = __webpack_public_path__ + "media/wood_4.46553798.webm";